export enum MessagingQueryKey {
	GetMessageConditionsSingle = 'GetMessageConditionsSingle',
	GetMessageConditionsAuto = 'GetMessageConditionsAuto',
	GetSMSProviders = 'GetSMSProviders',
	GetSMSProviderSenders = 'GetSMSProviderSenders',
	GetMessageTransactionHistory = 'GetMessageTransactionHistory',
	GetChannelTransactions = 'GetChannelTransactions',
	GetAllAutoMessages = 'GetAllAutoMessages',
	GetAutoMessageById = 'GetAutoMessageById',
	GetIntervalMessages = 'GetIntervalMessages',
	GetIntervalMessageById = 'GetIntervalMessageById',
	GetMessagingAnalytics = 'GetMessagingAnalytics',
	GetFlexMessageAnalytics = 'GetFlexMessageAnalytics',
	GetBrokeFlexMessageCampaigns = 'GetBrokeFlexMessageCampaigns',
	GetBrokeFlexMessageCampaign = 'GetBrokeFlexMessageCampaign',
}

export enum MessagingMutationKey {
	GroupPlayersByCondition = 'GroupPlayersByCondition',
	CreateMessageTransaction = 'CreateMessageTransaction',
	CreateAutoMessageTransaction = 'CreateAutoMessageTransaction',
	UpdateAutoMessage = 'UpdateAutoMessage',
	DeleteAutoMessage = 'DeleteAutoMessage',
	CreateIntervalMessage = 'CreateIntervalMessage',
	UpdateIntervalMessage = 'UpdateIntervalMessage',
	DeleteIntervalMessage = 'DeleteIntervalMessage',
	CreateBrokeFlexMessageCampaign = 'CreateBrokeFlexMessageCampaign',
	UpdateBrokeFlexMessageCampaign = 'UpdateBrokeFlexMessageCampaign',
	DeleteBrokeFlexMessageCampaign = 'DeleteBrokeFlexMessageCampaign',
}

export const MESSAGING_KEYS = {
	BROKE_FLEX_MESSAGE: {
		ALL: ['broke-flex-message'] as const,
		LIST: ['broke-flex-message', 'list'] as const,
		DETAIL: (id: string) => ['broke-flex-message', 'detail', id] as const,
	},
}

export const BROKE_FLEX_MESSAGE_KEYS = {
	ALL: ['broke-flex-message'] as const,
	LIST: ['broke-flex-message', 'list'] as const,
	DETAIL: (id: string) => ['broke-flex-message', 'detail', id] as const,
	PRESETS: ['broke-flex-message', 'presets'] as const,
	ANALYTICS: ['broke-flex-message', 'analytics'] as const,
	ANALYTICS_DETAIL: (campaignId: string) =>
		['broke-flex-message', 'analytics', campaignId] as const,
}
